import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Pin, Calendar } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, SectionHeading } from "@/components/site/primitives";

export function AnnouncementsPreview() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/announcements", { params: { limit: 4 } }).then(({ data }) => setItems(data.slice(0, 4))).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="relative py-20 sm:py-28 bg-white" data-testid="announcements-preview">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading overline="News & Announcements" title="Latest From the School" />
          <Link to="/announcements" className="btn-outline-gold !text-[#0A1E4E] !border-[#0A1E4E] hover:!bg-[#0A1E4E] hover:!text-white !py-2.5" data-testid="view-all-announcements">
            View All Announcements <ArrowUpRight size={15} />
          </Link>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((a, i) => (
            <Reveal key={a.id} delay={(i % 2) * 0.08}>
              <div className="group h-full rounded-sm border border-slate-200 bg-[#F7F5EF] p-7 transition-all hover:border-[#D4AF37] hover:shadow-lg">
                <div className="flex items-center gap-3 text-xs">
                  <span className="rounded-full bg-[#0A1E4E] px-3 py-1 font-semibold uppercase tracking-wide text-[#D4AF37]">{a.category}</span>
                  {a.pinned && <span className="inline-flex items-center gap-1 text-[#C0202A] font-semibold"><Pin size={12} /> Pinned</span>}
                  <span className="inline-flex items-center gap-1 text-slate-500"><Calendar size={13} /> {a.date}</span>
                </div>
                <h3 className="mt-4 font-serif text-xl font-bold text-[#0A1E4E]">{a.title}</h3>
                <p className="mt-2 text-slate-600 leading-relaxed line-clamp-3">{a.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
